// Module
var code = "<mn-procedure-table details=\"vm.item.details\" readonly=\"true\" flex></mn-procedure-table>";
// Exports
module.exports = code;